import { Link } from "react-router-dom";
import { ArticleMedia } from "../V2Shared";
import { ageMinutes } from "../tokens";
import { H3, h3Age, h3AgeShort } from "./h3";

/* More Breaking Stories — Figma 214:43 base geometry, amended by the Founder
   correction (2026-06): rank badges removed entirely, thumbnails enlarged and
   shifted left, headlines upsized. Real breaking queue, server-deduped;
   truthful relabel to LATEST STORIES when the queue is thin. */
export const MoreBreakingRail = ({ rail, latest }: { rail: any[]; latest: any[] }) => {
  const usingBreaking = rail.length >= 2;
  const items = (usingBreaking ? rail : latest).slice(0, 5);
  if (!items.length) return null;
  return (
    <div data-testid="h3-more-breaking" className="rounded-[10px] xl:rounded-[6px] p-[16px] flex flex-col"
      style={{ background: H3.card, border: `1px solid ${H3.border}` }}>
      <div className="flex items-center justify-between gap-[10px]">
        <p className="nl-geist text-[14px] md:text-[15px] xl:text-[13px] leading-[19px] font-bold" style={{ color: H3.text }}>
          {usingBreaking ? "MORE BREAKING STORIES" : "LATEST STORIES"}
        </p>
        <Link to="/latest" data-testid="h3-more-breaking-viewall"
          className="nl-mono text-[10px] xl:text-[10px] leading-[14px] hover:opacity-80 transition-opacity"
          style={{ color: H3.violetText }}>
          VIEW ALL →
        </Link>
      </div>
      <div className="mt-[4px] flex-1 flex flex-col justify-around">
        {items.map((a, i) => {
          const fresh = i === 0 && usingBreaking && (ageMinutes(a.breaking_at || a.published_at) ?? 99) <= 10;
          return (
            <div key={a.id} className={i === 4 ? "md:hidden xl:block" : ""}>
              <div className={`flex items-center gap-[12px] py-[12px] xl:py-[13px] ${i > 0 ? "border-t" : ""}`}
                style={{ borderColor: "#1e283a" }} data-testid={`h3-rail-item-${i + 1}`}>
                <span className="hidden xl:block shrink-0">
                  <ArticleMedia article={a} className="w-[72px] h-[72px] rounded-[6px]" />
                </span>
                <Link to={`/article/${a.slug}`} className="min-w-0 flex-1 group">
                  <p className="nl-geist text-[12px] leading-[16px] md:text-[13px] md:leading-[18px] xl:text-[12px] xl:leading-[16px] font-semibold xl:font-medium line-clamp-2 md:line-clamp-1 xl:line-clamp-2 group-hover:text-white transition-colors"
                    style={{ color: H3.text }}>
                    {a.title}
                  </p>
                  <span className="hidden xl:block nl-mono text-[9px] leading-[13px] mt-[5px]"
                    style={{ color: fresh ? H3.red : H3.gray }}>
                    {h3Age(a.breaking_at || a.published_at)}
                  </span>
                </Link>
                <span className="xl:hidden nl-mono text-[9px] md:text-[10px] leading-[14px] shrink-0"
                  style={{ color: fresh ? H3.redTouch : H3.grayTouch }}>
                  {h3AgeShort(a.breaking_at || a.published_at)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
